export default __webpack_public_path__ + "static/media/loginSVG.b38f568e.svg";